import { useRef } from "react";
import { FloorModel } from "proximiio-js-library/lib/models/floor";
import { AnimatePresence, motion } from "framer-motion";
import { cn, getFloorName } from "@/lib/utils";

import useMapStore from "@/store/mapStore";

function FloorPicker() {
  //store state
  const map = useMapStore((state) => state.map);
  const floors = useMapStore((state) => state.floors);
  const currentLang = useMapStore((state) => state.currentLang);
  const currentFloor = useMapStore((state) => state.currentFloor);
  const routeFinish = useMapStore((state) => state.routeFinish);
  const mobileMode = useMapStore((state) => state.mobileMode);
  const activeMenuItem = useMapStore((state) => state.activeMenuItem);
  const activeFilter = useMapStore((state) => state.activeFilter);
  const ref = useRef<HTMLDivElement>(null);

  const handleFloorClick = (floor: FloorModel) => {
    if (Object.keys(map).length > 0) {
      setTimeout(() => {
        map.setFloorById(floor.id);
      }, 300);
    }
  };

  const haveLongFloorName = (floorName?: string) => {
    if (floorName && floorName.length > 3) {
      return true;
    }
    return false;
  };

  const floorsList = floors.sort((a, b) => a.level - b.level).map((floor, idx) => {
    if (floor.level !== 0 && floor.level !== 1 && floor.level !== 2) {
      return;
    }
    return (
      <motion.div
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{
          type: "spring",
          stiffness: 260,
          damping: 20,
          delay: 0.1 + idx / 10,
        }}
        key={floor.id}
        onClick={() => handleFloorClick(floor)}
        className={cn(
          "flex h-9 min-w-9 cursor-pointer items-center justify-center rounded-lg bg-white px-1 text-xs font-bold shadow-[0px_1px_6px_3px_rgba(0,0,0,0.5)] hover:text-primary hover:shadow-[0px_1px_6px_3px_rgba(0,0,0,0.7)] lg:h-12 lg:min-w-12 lg:px-2 lg:text-lg",
          currentFloor?.id === floor.id &&
            "hover:primary bg-primary text-white hover:text-white",
          !haveLongFloorName(getFloorName({ floor, language: currentLang })) &&
            "px-2 lg:px-6",
        )}
      >
        {getFloorName({ floor, language: currentLang })}
      </motion.div>
    );
  });

  if (mobileMode && routeFinish?.id) {
    return <></>;
  }

  return (
    <AnimatePresence>
      {floorsList.length > 1 && (
        <div>
          <div
            ref={ref}
            className={cn(
              `absolute z-[9] flex w-auto flex-col-reverse justify-stretch gap-2 group-data-[dir=ltr]:right-5 group-data-[dir=rtl]:left-5 lg:gap-3 lg:group-data-[dir=ltr]:right-10 lg:group-data-[dir=rtl]:left-10`,
              ref.current && `top-[var(--content-offset)]`,
              mobileMode &&
                (activeMenuItem !== "map" || activeFilter?.id) &&
                "top-24",
            )}
            style={{
              // @ts-expect-error: custom property
              "--content-offset": `calc(${mobileMode ? "50dvh" : "50%"} - ${
                ref.current?.offsetHeight ? ref.current.offsetHeight / 2 : 0
              }px)`,
            }}
          >
            {floorsList}
          </div>
        </div>
      )}
    </AnimatePresence>
  );
}
export default FloorPicker;
